

































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Button from '@/components/common/elements/Button.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import FileManager from '@/components/common/modules/FileManager.vue';
import InputArea from '@/components/common/modules/InputArea.vue';
import MultipleLineText from '@/components/common/elements/MultipleLineText.vue';
import Input from '@/components/common/elements/Input.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import DialogMailPreview from '@/components/common/modules/DialogMailPreview.vue';
import {
  previewDialog,
  sendDialog,
  sendCompletedDialog,
  mailTextAnnotation
} from '@/constants/matter/matter';

import hexabaseState from '@/store/hexabase';
import FileClass from '@/models/lib/file';
import { FileFormResponse, CheckBoxProps } from '@/constants/form/types';

@Component({
  components: {
    Button,
    SingleText,
    FileManager,
    InputArea,
    MultipleLineText,
    Input,
    Dialog,
    DialogMailPreview
  }
})
export default class SendTab extends Vue {
  private File = new FileClass();

  inheritAttrs = false;
  @Prop({ default: () => ({}) })
  private item: any;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  private isPersistent?: boolean = true;
  private projectId = hexabaseState.applicationId;

  // チェック状況
  private checkBoxs: Array<CheckBoxProps> = [];
  private checkStatus: {[k: string]: boolean} = {};

  private previewDialog: any = {};
  private sendDialog: any = {};
  private sendComplete: any = {};
  private mailTextAnnotation: any = '';

  async mounted() {
    this.previewDialog = previewDialog;
    this.sendDialog = sendDialog;
    this.sendComplete = sendCompletedDialog;
    this.mailTextAnnotation = mailTextAnnotation;
    this.getItemData();
    this.checkBoxs = this.item.fileSelect.items;
  }

  // 送信タブイベント
  @Emit('tabChildrenEventRelay')
  private formSelectDialogOpenButton() {
    this.item.showDialog = true;
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'formSelectDialogOpenButton';
    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  private masterSelectEventRelay(response: any) {
    response.functionName = 'masterSelectEventRelay';
    return response;
  }

  // テーブルで選択されたファイル情報を取得
  @Emit('tabChildrenEventRelay')
  private selectItemHandle(data: any): void {
    // this.selectItem = data;
  }

  @Emit('tabChildrenEventRelay')
  public inputMailAddress(data: any, index?: number) {
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'inputMailAddress';
    responseData.data = data;
    responseData.index = index;

    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  public inputMailTitle(data: any) {
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'inputMailTitle';
    responseData.data = data;

    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  public inputMailText(data: any) {
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'inputMailText';
    responseData.data = data;

    return responseData;
  }

  private closeFileManager() {
    this.item.showDialog = false;
  }

  private setLoading(bool: boolean) {
    this.$store.commit('hexabase/setIsLoading', bool);
  }

  @Emit('tabChildrenEventRelay')
  private emitFileData(event: FileFormResponse) {
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'catchFileForm';
    responseData.event = event;

    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  private getItemData() {
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'getItemData';
    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  private mailPreviewButton() {
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'mailPreview';
    previewDialog.isPreviewDialog = true;
    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  private sendMailButton(response: any) {
    const responseData: any = {};
    if (response.isAgree) {
      sendDialog.isSendDialog = true;
      responseData.action = 'sendTab';
      responseData.eventName = 'mailSend';
    } else {
      previewDialog.isPreviewDialog = false;
      responseData.action = 'sendTab';
      responseData.eventName = 'previewDialogClose';
    }
    return responseData;
  }

  private sendCompleted() {
    sendCompletedDialog.isSendDialog = false;
    this.$router.go(0);
  }

  @Emit('tabChildrenEventRelay')
  private sendMail(response: any) {
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'sendMail';
    if (response.isAgree) {
      responseData.isAgree = true;
    } else {
      responseData.isAgree = false;
    }
    sendDialog.isSendDialog = false;
    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  private checkBoxOperatipon(data: any) {
    this.checkStatus[data.form_name] = !this.checkStatus[data.form_name];
    const responseData: any = {};
    responseData.action = 'sendTab';
    responseData.eventName = 'checkBoxOperatipon';
    responseData.data = data;
    responseData.data['checkStatus'] = this.checkStatus[data.form_name];

    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  private emit(response: any) {
    return response;
  }
}
